/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateInsuranceRulesRequestRulesInner } from './UpdateInsuranceRulesRequestRulesInner';
import {
    UpdateInsuranceRulesRequestRulesInnerFromJSON,
    UpdateInsuranceRulesRequestRulesInnerFromJSONTyped,
    UpdateInsuranceRulesRequestRulesInnerToJSON,
    UpdateInsuranceRulesRequestRulesInnerToJSONTyped,
} from './UpdateInsuranceRulesRequestRulesInner';

/**
 * 
 * @export
 * @interface UpdateInsuranceRulesRequest
 */
export interface UpdateInsuranceRulesRequest {
    /**
     * 
     */
    rules: Array<UpdateInsuranceRulesRequestRulesInner>;
}

/**
 * Check if a given object implements the UpdateInsuranceRulesRequest interface.
 */
export function instanceOfUpdateInsuranceRulesRequest(value: object): value is UpdateInsuranceRulesRequest {
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function UpdateInsuranceRulesRequestFromJSON(json: any): UpdateInsuranceRulesRequest {
    return UpdateInsuranceRulesRequestFromJSONTyped(json, false);
}

export function UpdateInsuranceRulesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInsuranceRulesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rules': ((json['rules'] as Array<any>).map(UpdateInsuranceRulesRequestRulesInnerFromJSON)),
    };
}

export function UpdateInsuranceRulesRequestToJSON(json: any): UpdateInsuranceRulesRequest {
    return UpdateInsuranceRulesRequestToJSONTyped(json, false);
}

export function UpdateInsuranceRulesRequestToJSONTyped(value?: UpdateInsuranceRulesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rules': ((value['rules'] as Array<any>).map(UpdateInsuranceRulesRequestRulesInnerToJSON)),
    };
}

